import { AppConfig } from "../utils/Interfaces"

function getLocalIP(): string {
    const localIP = window.location.hostname;
    const knownPort = process.env.REACT_APP_KNOWN_PORT

    const knownIPs = process.env.REACT_APP_KNOWN_IPS
        ? process.env.REACT_APP_KNOWN_IPS.split(",").map((ip) => ip.trim())
        : [];

    if (knownIPs.includes(localIP)) {
        return `http://${localIP}:${knownPort}`;
    }

    return process.env.REACT_APP_URL;
}

function getBackendURL(): string {
    const isProduction = process.env.NODE_ENV === "production";
    const isRemoteMode = process.env.REACT_APP_REMOTE_MODE === "true";

    if (isProduction || isRemoteMode) {
        // Always use the production core URL in production or remote mode
        return process.env.REACT_APP_CORE!;
    }

    const localIP = getLocalIP().replace("http://", "").split(":")[0];
    return `http://${localIP}:81${process.env.REACT_APP_CORE_PATH}`;
}


const Config: AppConfig = {
    APP_URL: getLocalIP(),
    APP_CORE: getBackendURL(),
    APP_NAME: process.env.REACT_APP_NAME,
    API_KEY: undefined,
    COOKIE: {
        SECURE: process.env.REACT_APP_COOKIE_SECURE,
        SAME_SITE: process.env.REACT_APP_COOKIE_SAME_SITE,
    },
    logging: {
        level: 'error',
        remoteLogging: false
    },
    version: process.env.REACT_APP_VERSION,
}

export default Config